export function resolveTaxRateValue(taxRates = [], taxRateId) {
  const match = taxRates.find((rate) => String(rate.id) === String(taxRateId));
  const value = parseFloat(match?.rate);
  return Number.isFinite(value) ? value : 0;
}

export function parseAmount(value) {
  const num = typeof value === 'number' ? value : parseFloat(value);
  return Number.isFinite(num) ? num : NaN;
}

export function deriveFromSale({ costExclTax, salePriceInclTax, taxRate }) {
  const cost = parseAmount(costExclTax);
  const saleInc = parseAmount(salePriceInclTax);
  const rate = Number.isFinite(taxRate) ? taxRate : 0;

  if (!Number.isFinite(saleInc)) {
    return { salePriceExclTax: NaN, marginPercent: NaN };
  }

  const saleEx = saleInc / (1 + rate || 1);
  if (!Number.isFinite(saleEx)) {
    return { salePriceExclTax: NaN, marginPercent: NaN };
  }

  const profit = saleEx - (Number.isFinite(cost) ? cost : 0);
  const marginPercent = saleEx !== 0 ? (profit / saleEx) * 100 : 0;

  return {
    salePriceExclTax: saleEx,
    marginPercent,
  };
}

export function deriveFromMargin({ costExclTax, marginPercent, taxRate }) {
  const cost = parseAmount(costExclTax);
  const margin = parseAmount(marginPercent);
  const rate = Number.isFinite(taxRate) ? taxRate : 0;

  if (!Number.isFinite(cost) || !Number.isFinite(margin)) {
    return null;
  }

  const marginDecimal = margin / 100;
  if (marginDecimal >= 1) {
    return null;
  }

  const saleEx = cost / (1 - marginDecimal);
  const saleInc = saleEx * (1 + rate);

  if (!Number.isFinite(saleEx) || !Number.isFinite(saleInc)) {
    return null;
  }

  return {
    salePriceExclTax: saleEx,
    salePriceInclTax: saleInc,
  };
}

export function formatMoney(value, fallback = '') {
  return Number.isFinite(value) ? value.toFixed(2) : fallback;
}

export function formatPercent(value, fallback = '') {
  return Number.isFinite(value) ? value.toFixed(2) : fallback;
}
